import { cardAnatomy } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers } from "@chakra-ui/react";

const { definePartsStyle, defineMultiStyleConfig } =
  createMultiStyleConfigHelpers(cardAnatomy.keys);

const baseStyle = definePartsStyle({
  container: {
    backdropFilter: "auto",
    backdropBlur: "16px",
    backgroundColor: "transparent",
    borderColor: "white",
    borderRadius: "15px",
    borderStyle: "solid",
    color: "white",
    flexShrink: 0,
  },
});

const closedStyle = definePartsStyle({
  container: {
    borderRadius: "50px",
    padding: "20px",
    bgGradient: "linear(135deg, #9090904D, #9090900D)",
    boxShadow: `0px 10px 25px #00000033`,
    borderWidth: "1px",
    borderColor: "#FFFFFF55",
  },
  header: {
    bgGradient: "linear(135deg, #9AA5AE77, #9AA5AE11)",
    borderWidth: "1px",
    borderColor: "#FFFFFF55",
    borderStyle: "solid",
    borderRadius: "35px",
    padding: "5px",
  },
  body: {
    display: "none"
  },
});

const navigationStyle = definePartsStyle({
  container: {
    bgGradient: "linear(135deg, #9AA5AE99, #9AA5AE33)",
    borderRadius: "15px",
    borderWidth: "1px",
    borderColor: "#FFFFFF55",
    boxShadow: `0px 10px 25px #00000033`,
  },
  body: {
    padding: "15px",
  }
});

const openedStyle = definePartsStyle({
  container: {
    bgGradient: "linear(135deg, #9090904D, #9090900D)",
    borderWidth: "1px",
    borderColor: "#FFFFFF55",
    borderRadius: "15px",
    boxShadow: `0px 10px 25px #00000033`,
    padding: "16px",
  },
  header: {
    borderTopRadius: "15px",
    padding: "5px",
  },
  body: {
    padding: "5px",
    borderBottomRadius: "15px"
  },
});

const primaryStyle = definePartsStyle({
  container: {
    backgroundColor: "#9AA5AE99",
    borderWidth: "1px",
    borderColor: "#FFFFFF55",
    boxShadow: `0px 10px 25px #00000033`,
    height: "full",
    padding: "5px",
    width: "full",
  },
  header: {
    padding: "5px",
  },
  body: {
    borderRadius: "15px",
    padding: "5px",
  },
});

const secondaryStyle = definePartsStyle(({ colorScheme }) => ({
  container: {
    backgroundColor: colorScheme === "gray" ? "none" : `${colorScheme}.500`,
    backgroundPosition: "center",
    backgroundSize: "20vw, 20vh",
    bgGradient: "linear(rgba(210,219,229,.2), rgba(210,219,229,.2))",
    borderColor: colorScheme === "gray" ? "white" : colorScheme,
    borderRadius: "5px",
    borderWidth: "1px",
    height: "full",
    width: "full",
  },
  header: {
    padding: "5px",
  },
  body: {
    borderColor: "inherit",
    borderTopWidth: "1px",
    borderStyle: "solid",
    height: "full",
    padding: "5px",
    width: "full",
  },
}));

const cardTheme = defineMultiStyleConfig({
  baseStyle,
  variants: {
    closed: closedStyle,
    navigation: navigationStyle,
    opened: openedStyle,
    primary: primaryStyle,
    secondary: secondaryStyle,
  },
});

export default cardTheme;
